export { default } from './AgeRestriction';
